const secrets = {
  serverUrl: 'https://caebes.com:6567',
  // serverUrl: 'http://127.0.0.1:1337',
};

export default secrets;
